import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
];

export const TestimonialRoutingProvider = RouterModule.forRoot(routes, { useHash: true });